
import { Box, Button, Grid, TextField, TextFieldProps, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers/';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { useEffect, useState } from 'react'
import { FormikErrors, useFormik } from 'formik';
import styles from '../styles/dateToGenerateReports.module.scss';
import '../styles/_dateGenerate.scss';
import 'dayjs/locale/es'
import utc from 'dayjs/plugin/utc'
import { validateDateRangeByMonth } from 'shared/utils';
import { IDatasToGenerate } from '../types/IDatasToGenerate';
import DateTypeSelector from './DateTypeSelector';

const mockListPPNA = [12,13,17];

export const DatesToGenerateReports = ({ titleOK, onOk, onClose, idCard }: IDatasToGenerate) => {

    const [valueInitialDate, setValueInitialDate] = useState<Dayjs | null>(null);
    const [valueFinalDate, setValuevalueFinalDate] = useState<Dayjs | null>(null);
    const [selectedDateType, setSelectedDateType] = useState<{value: string, label: string} | null>(null);
    let rangeMonthDefault = 6;
    
    useEffect(() => {
        dayjs.extend(utc)
    }, [])

    const validate = () => {
        const errors: FormikErrors<any> = {};

        if ( idCard && Number(idCard) > 9) {
            rangeMonthDefault = 14;
        }

        if(valueInitialDate === null){
           errors.initialDate = 'Campo requerido';
        }
        if(valueFinalDate === null){
            errors.finalDate = 'Campo requerido'
        }

        if (!valueInitialDate?.isValid() || !valueFinalDate?.isValid()) {
            errors.range ="Las fechas tienen un formato incorrecto"
        }

        handleFinalDateChange(valueFinalDate) && (errors.range = 'La Fecha final no puede ser anterior a la Fecha inicial');
        validateDateRangeByMonth(valueInitialDate, valueFinalDate, rangeMonthDefault) && (errors.range = `Por favor introduzca un rango de  fechas que no supere ${rangeMonthDefault} meses`);

        return errors;
    }

    const { handleSubmit, errors } = useFormik({
        initialValues: {
            initialDate: valueInitialDate,
            finalDate: valueFinalDate,
            range: ''
        },
        onSubmit: () => { onOk(dayjs.utc(valueInitialDate).format('DD/MM/YYYY'), dayjs.utc(valueFinalDate).format('DD/MM/YYYY'), selectedDateType?.value )},
        
        validate,
    })

    const renderInput =(params: TextFieldProps) => {
        return(
          <Box sx={{display:'flex', alignItems: 'center'}} className={styles.dataPicker}>
              <TextField 
                  {...params} 
                  onKeyDown={(e:any) => { e.which === 13 && e.preventDefault() }}
                  inputProps={{ 
                        ...params.inputProps,
                        'data-testid': `input_date_from_${params.InputProps?.name}` 
                    }}
                  focused 
              />
          </Box>
        )
    }

    const handleFinalDateChange = (newValueInitial: Dayjs | null): boolean => {
        setValuevalueFinalDate(newValueInitial);
        let errorRange = false
        if (newValueInitial && valueInitialDate && newValueInitial.isBefore(valueInitialDate)) {
            errorRange = true;
        }

        return errorRange;
    };

    const selectLabelDescriptionStartDate = (idCard: number): string => {
        let labelDescription = `Desde`;
        if (idCard && Number(idCard) > 9) labelDescription = `Fecha Inicial de ${selectedDateType?.label}`;
        
        return labelDescription;
    }

    const selectLabelDescriptionEndDate = (idCard: number): string => {
        let labelDescription = `Hasta`;
        if (idCard && Number(idCard) > 9) labelDescription = `Fecha Final de ${selectedDateType?.label}`;
        
        return labelDescription;
    }

    useEffect(() => {
      if (mockListPPNA.includes(Number(idCard))) {
        setSelectedDateType({ value: 'issuedDate', label: 'expedición de la factura' });
      }
    }, [])
    

    return (
        <form onSubmit={handleSubmit} className={`${styles.dataToGenerate} data-generate`} data-testid='form_dates_generate' >
            {!mockListPPNA.includes(Number(idCard)) && <DateTypeSelector value={selectedDateType?.value || null} onChange={setSelectedDateType} />}
            {
                (selectedDateType || mockListPPNA.includes(Number(idCard))) && (
                    <Grid container direction={"row"} className={styles.containerDateGrid} data-testid='grid_container'>
                            <Grid item xs={12}  lg={6} className={ styles.containerGridItem }>
                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"es"}>
                                    <DatePicker
                                        label={ selectLabelDescriptionStartDate(Number(idCard)) }
                                        toolbarPlaceholder={ selectLabelDescriptionStartDate(Number(idCard)) }
                                        className={`${styles.contentDatePicker} `}
                                        value={valueInitialDate}
                                        onChange={(newValue) => { setValueInitialDate(newValue) }}
                                        renderInput={(params) => renderInput(params)}
                                        InputProps={{
                                            name: 'initialDate',
                                        }}
                                        data-testid='datapicker_date_to'
                                        PopperProps={{
                                            className: 'pickers_popper'
                                        }}
                                    />
                                    {
                                        errors.initialDate && <Typography className={styles.errorMessage} data-testid='text_error_initial_date' >{errors.initialDate}</Typography>
                                    }
                                </LocalizationProvider>   
                            </Grid>

                            <Grid item xs={12}  lg={6} className={ styles.containerGridItem }>
                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"es"}>
                                    <DatePicker
                                        label={ selectLabelDescriptionEndDate(Number(idCard)) }
                                        toolbarPlaceholder={ selectLabelDescriptionEndDate(Number(idCard)) }
                                        className={styles.contentDatePicker}
                                        value={valueFinalDate}
                                        onChange={(newValue) => { setValuevalueFinalDate(newValue) }}
                                        renderInput={(params: any) => renderInput(params)}
                                        InputProps={{
                                            name: 'finalDate',
                                        }}
                                        data-testid='datapicker_date_from'
                                        PopperProps={{
                                            className: 'pickers_popper'
                                        }}
                                    />
                                    {
                                        errors.finalDate && <Typography className={styles.errorMessage} data-testid='text_error_final_date' >{errors.finalDate}</Typography>
                                    }
                                </LocalizationProvider>
                            </Grid>
                            {
                                errors.range && <Typography className={styles.errorMessage} data-testid='text_error_range'>{errors.range}</Typography>
                            }
                    </Grid>
                    )
                }
                <Grid container direction={"row"} justifyContent={'center'} className={styles.buttonContainer}>
                    {
                        selectedDateType && (
                            <Button type='submit' variant='contained' color='secondary' className={styles.buttonSubmit} data-testid="btn_ok">
                                {titleOK}
                            </Button>
                        )
                    }
                    <Button variant='contained' color='secondary' className={styles.buttonCancelar} onClick={onClose} data-testid='btn_close'>
                        Cancelar
                    </Button>
                </Grid>
        </form>
    )
}
